import { Component } from '@angular/core';
import { WordConverter } from 'src/app/core/helpers/word-converter';
import { DocumentStatus, TemplateDocumentType } from 'src/app/core/models/document/document-template-model';
import { MyfileModalComponent } from '../myfile-modal/myfile-modal.component';

@Component({
  selector: 'app-cheque-myfile-modal',
  templateUrl: './cheque-myfile-modal.component.html',
  styleUrls: ['./cheque-myfile-modal.component.scss']
})
export class ChequeMyfileModalComponent extends MyfileModalComponent {
  
  btnCovertToWordsVisible = false;
  
  includeTaxOptionsList = [
    { value: `false`, selectedText: $localize`:@@:Exempt Tax`,  default: true  },
    { value: `true`, selectedText: $localize`:@@:Includes Tax` },
  ]


  override ngOnInit(): void {
    if (this.myfile.status == DocumentStatus.New) {
      this.disableEditing = false;
    }
      this.btnCovertToWordsVisible = true;
      if (this.myfile.customFields && this.myfile.customFields[0].value && this.myfile.customFields[1].value == "") {
        this.myfile.customFields[1].value = WordConverter.paymentAmountStringToWords(this.myfile.customFields[0].value) 
      }

  }

  amountNumToWords(){
    if (this.myfile.customFields && this.myfile.customFields[0].value){
      this.myfile.customFields[1].value = WordConverter.paymentAmountStringToWords(this.myfile.customFields[0].value) 
    }
  }

}
